<script>
    export default {
        data() {
            return {
                errorText: '',
            }
        },
        computed: {
            addData() {return this.$store.getters.PAG_PROVIDER_ADD}
        },
        methods: {
            async changeData(event, fieldName, isCheckBox = false) {

                const data = isCheckBox === true ? 
                    event.target.checked :
                    event.target.value;
                this.$store.commit('PAG_PROVIDER_ADD_UPDATE', {
                    fieldName: fieldName, 
                    fieldValue: data,
                });
                this.errorText = await this.$store.dispatch('CHECK_PROVIDER_ADD');
            }
        }
    }
</script>


<template>
    <div class="left_sub_panel_data">
        <label>Name:</label>
        <input 
            @change="changeData($event, 'name')"
            :value="addData['name']"
            type="text"
            class="right_input mb_10 mt_5"
        >
        <label>
            <input 
                @change="changeData($event, 'is_premium', true)"
                :checked="addData['is_premium']"
                type="checkbox"
            >
            Premium
        </label>
        <label>
            <input
                @change="changeData($event, 'is_default', true)"
                :checked="addData['is_default']"
                type="checkbox"
            >
            Default
        </label>

        <label
            v-if="errorText !== ''"
            class="error_text mt_10"
        >{{ errorText }}</label>
    </div>    
</template>